const local = {
  instruction: "DNA如何影响Puppy？",
  races: ["沙皮犬", "牧羊犬", "猎浣熊犬", "阿富汗猎犬", "大丹犬"],
  scale: ["小型", "中型", "大型"],
  serialNumber: "DNA",
  specialid: "特殊标识",
  race: "Puppy种类",
  economic: "经济",
  military: "军事",
  cards: [
    "Puppy大小",
    "Puppy体型",
    "Puppy颜色",
    "徽标样式",
    "徽标颜色",
    "徽标位置",
    "Puppy种类",
    "特殊标识",
  ],
};

export { local };
